.spw-accordion-content {
  line-height: 1.5;
  font-weight: 400;
  overflow: hidden;
  color: var(--spw-color-themes-grey-grey-600);
  transition: all 0.25s ease-in;

  :host(.--collapsed) & {
    max-height: 0 !important;
  }

  &--is-opened {
    max-height: 100% !important;
  }

  &__inner {
    padding: 0 var(--spw-spacings-spacing-lg);
    margin-bottom: var(--spw-spacings-spacing-lg);
  }
}
